import React from 'react';

const CTASection = () => {
  return (
    <section className="py-16 sm:py-24 px-3 sm:px-4 bg-gradient-to-br from-[#25D366] to-[#128C7E] overflow-hidden">
      <div className="max-w-5xl mx-auto text-center">
        <h2 className="text-xl sm:text-3xl md:text-5xl font-bold text-white mb-4 sm:mb-6">
          Grow Better with <span className="italic">waatee</span> today
        </h2>
        <p className="text-white/80 text-sm sm:text-lg mb-8 sm:mb-10 max-w-2xl mx-auto px-2">
          Streamlining Chatbot Management: Join 3.5K+ businesses transforming their customer interactions
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 px-2">
          <a
            href="https://app.waatee.com/register"
            className="w-full sm:w-auto bg-white text-gray-900 px-6 sm:px-8 py-3 sm:py-4 rounded-full text-sm sm:text-lg font-medium hover:bg-gray-100 transition-all shadow-lg"
          >
            Book a Demo
          </a>
          <a
            href="https://app.waatee.com/register"
            className="w-full sm:w-auto bg-transparent text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full text-sm sm:text-lg font-medium border-2 border-white hover:bg-white/10 transition-all"
          >
            Try for Free
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
